import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { makeAuthenticatedRequest } from "../utils/api";
import { loginOtp } from "../redux/LoginSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";

const ForgotOtp = () => {
  const [otpEmail, setOtpEmail] = useState(["", "", "", "", "", ""]);
  const [otpMobile, setOtpMobile] = useState(["", "", "", "", "", ""]);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({ username: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const otpRefs = useRef([]);
  const dispatch = useDispatch();

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, ""); // Only digits
    if (!value) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (index < 5 && value) otpRefs.current[index + 1].focus();
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
      if (index > 0) otpRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = { username: "" };
    let isValid = true;

    const enteredOtp = otp.join("");
    if (enteredOtp.length < 6) {
      newErrors.username = "Please enter the full 6-digit OTP.";
      isValid = false;
    } else if (!/^\d{6}$/.test(enteredOtp)) {
      newErrors.username = "OTP must contain only digits.";
      isValid = false;
    }

    setErrors(newErrors);
    if (!isValid) return;

    setLoading(true);
    try {
      const requestData = JSON.stringify({
        email: email,
        otp: otp.join(""),
        otp_id: otp_id,
      });

      const encrypted = encrypt(requestData);

      const data = await makeAuthenticatedRequest(
        "POST",
        "/otp/validate",
        { encrypted },
        navigate
      );
      const decryptdata = decrypt(data);
      const fixedString = decryptdata
        .replace(/\\"/g, '"')
        .replace(/^"|"$/g, "");

      const jsonObject = JSON.parse(fixedString);

      if (jsonObject.Status === "200") {
        toast.success(jsonObject.Msg);
        setShowSuccess(true);
        setTimeout(() => {
          navigate("/setnewpassword");
        }, 1500);
      } else if (jsonObject.Status === "401") {
        toast.error(jsonObject.Err);
      }
    } catch (error) {
      toast.error("Invalid OTP code. Please verify and try again.");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const login_Otp = useSelector((state) => state.login?.loginData);
  const registerOtp = useSelector((state) => state.login?.RegisterOtp);
  const ForgOtp = useSelector((state) => state.login?.ForgOtp);
  const email =
    registerOtp?.userdatils?.email ||
    login_Otp?.userdatils?.email ||
    ForgOtp?.userdatils?.email ||
    "";
  const mid = String(
    registerOtp?.userdatils?.user_id ||
      login_Otp?.userdatils?.user_id ||
      ForgOtp?.userdatils?.user_id ||
      ""
  );

  const loginotp = useSelector((state) => state.login?.otp);
  const otp_id = String(loginotp?.Otp_id || "");

  useEffect(() => {
    if (!email || !mid) return;
  
    let hasRun = false;
  
    const postData = async () => {
      if (hasRun) return;
      hasRun = true;
  
      try {
        const requestData = JSON.stringify({
          email,
          mid,
          type: "Registration",
        });
  
        const encrypted = encrypt(requestData);
  
        const data = await makeAuthenticatedRequest(
          "POST",
          "/otp/generate",
          { encrypted },
          navigate
        );
  
        const decryptdata = decrypt(data);
        const jsonArray = JSON.parse(decryptdata.replace(/\\"/g, '"'));
  
        dispatch(loginOtp(jsonArray));
      } catch (err) {
        console.error("OTP Generate Error:", err);
      }
    };
  
    postData();
  }, [email, mid, dispatch]);

  const handleBackToLogin = () => navigate("/login");

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .otp-root {
          min-height: 100vh;
          display: flex;
          font-family: 'Inter', sans-serif;
          background: #0f0f1a;
        }

        /* ── LEFT PANEL ── */
        .otp-left {
          flex: 1;
          display: none;
          position: relative;
          overflow: hidden;
          background: linear-gradient(145deg, #0d0d1f 0%, #1a0a3d 50%, #0d1a3d 100%);
        }

        @media (min-width: 1024px) {
          .otp-left { display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 3rem; }
        }

        /* Animated mesh orbs */
        .otp-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(85px);
          opacity: 0.5;
          pointer-events: none;
          animation: orbFloat 14s ease-in-out infinite;
        }
        .otp-orb-1 {
          width: 450px; height: 450px;
          background: radial-gradient(circle, rgba(99,91,255,0.55) 0%, transparent 70%);
          top: -100px; left: -100px;
          animation-duration: 16s;
        }
        .otp-orb-2 {
          width: 380px; height: 380px;
          background: radial-gradient(circle, rgba(139,92,246,0.45) 0%, transparent 70%);
          bottom: -80px; right: -80px;
          animation-duration: 20s;
          animation-direction: reverse;
        }

        @keyframes orbFloat {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(30px, -45px) scale(1.06); }
        }

        /* Grid dots overlay */
        .otp-grid {
          position: absolute;
          inset: 0;
          background-image: radial-gradient(circle, rgba(255,255,255,0.06) 1px, transparent 1px);
          background-size: 28px 28px;
          pointer-events: none;
        }

        /* Left panel content */
        .left-content {
          position: relative;
          z-index: 2;
          text-align: center;
          max-width: 440px;
        }

        .left-brand-icon {
          width: 72px; height: 72px;
          border-radius: 20px;
          background: linear-gradient(135deg, #635bff, #8b5cf6);
          display: flex; align-items: center; justify-content: center;
          margin: 0 auto 1.5rem;
          box-shadow: 0 12px 40px rgba(99,91,255,0.6), inset 0 1px 0 rgba(255,255,255,0.2);
        }

        .left-title {
          font-size: 2.5rem;
          font-weight: 800;
          line-height: 1.15;
          letter-spacing: -0.03em;
          background: linear-gradient(135deg, #fff 0%, #c4b5fd 60%, #818cf8 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 1rem;
        }

        .left-subtitle {
          font-size: 0.95rem;
          color: rgba(148,163,184,0.8);
          line-height: 1.65;
          font-weight: 400;
          margin-bottom: 2.5rem;
        }

        /* Feature pills */
        .feature-pills {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          align-items: flex-start;
          width: 100%;
        }

        .feature-pill {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.75rem 1.25rem;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 1rem;
          width: 100%;
          backdrop-filter: blur(10px);
        }

        .feature-pill-icon {
          width: 36px; height: 36px;
          border-radius: 10px;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
          font-size: 1.1rem;
        }

        .feature-pill-text strong {
          display: block;
          font-size: 0.82rem;
          font-weight: 600;
          color: #e2e8f0;
          margin-bottom: 1px;
        }
        .feature-pill-text span {
          font-size: 0.72rem;
          color: rgba(148,163,184,0.6);
        }

        /* ── RIGHT PANEL ── */
        .otp-right {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2.5rem 1.25rem;
          background: linear-gradient(160deg, #0f0f1a 0%, #13111f 100%);
          position: relative;
          overflow: hidden;
        }

        @media (min-width: 1024px) {
          .otp-right { width: 520px; flex-shrink: 0; }
        }

        /* Right subtle glow */
        .otp-right::before {
          content: '';
          position: absolute;
          top: -60px; right: -60px;
          width: 320px; height: 320px;
          background: radial-gradient(circle, rgba(99,91,255,0.08) 0%, transparent 70%);
          border-radius: 50%;
          pointer-events: none;
        }

        .otp-card {
          width: 100%;
          max-width: 420px;
          position: relative;
          z-index: 2;
        }

        /* Top brand for mobile */
        .mobile-brand {
          text-align: center;
          margin-bottom: 2rem;
        }

        @media (min-width: 1024px) {
          .mobile-brand { display: none; }
        }

        .mobile-brand-icon {
          width: 52px; height: 52px;
          border-radius: 14px;
          background: linear-gradient(135deg, #635bff, #8b5cf6);
          display: flex; align-items: center; justify-content: center;
          margin: 0 auto 0.75rem;
          box-shadow: 0 8px 24px rgba(99,91,255,0.5);
        }

        /* Heading */
        .otp-heading {
          margin-bottom: 0.375rem;
          text-align: center;
        }

        .otp-heading h1 {
          font-size: 1.75rem;
          font-weight: 800;
          color: #f1f5f9;
          letter-spacing: -0.025em;
          line-height: 1.2;
        }

        .otp-heading p {
          font-size: 0.875rem;
          color: rgba(148,163,184,0.7);
          margin-top: 0.5rem;
          font-weight: 400;
          line-height: 1.5;
        }

        .email-highlight {
          color: #a78bfa;
          font-weight: 600;
          word-break: break-all;
        }

        /* Divider */
        .otp-divider {
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(99,91,255,0.3), transparent);
          margin: 1.75rem 0;
        }

        /* Verification input grid */
        .otp-digit-row {
          display: flex;
          justify-content: space-between;
          gap: 0.5rem;
          margin: 1.5rem 0;
        }

        .otp-digit-input {
          width: 3.25rem;
          height: 3.5rem;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 0.75rem;
          text-align: center;
          font-size: 1.25rem;
          font-weight: 700;
          color: #f1f5f9;
          outline: none;
          transition: all 0.25s ease;
          font-family: 'Inter', sans-serif;
        }

        .otp-digit-input:focus {
          border-color: rgba(99,91,255,0.6);
          background: rgba(99,91,255,0.06);
          box-shadow: 0 0 0 3px rgba(99,91,255,0.12);
        }

        .otp-digit-input.error {
          border-color: rgba(239,68,68,0.5);
          background: rgba(239,68,68,0.04);
        }

        .otp-error-msg {
          font-size: 0.72rem;
          color: #f87171;
          margin-top: 0.5rem;
          display: flex;
          align-items: center;
          gap: 0.25rem;
          justify-content: center;
        }

        /* Submit button */
        .otp-submit-btn {
          width: 100%;
          padding: 0.9rem 1.5rem;
          background: linear-gradient(135deg, #635bff 0%, #7c3aed 100%);
          border: none;
          border-radius: 0.875rem;
          color: white;
          font-size: 0.9rem;
          font-weight: 700;
          font-family: 'Inter', sans-serif;
          cursor: pointer;
          transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
          box-shadow: 0 8px 24px rgba(99,91,255,0.45), inset 0 1px 0 rgba(255,255,255,0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          letter-spacing: 0.01em;
          position: relative;
          overflow: hidden;
        }

        .otp-submit-btn::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 50%);
          pointer-events: none;
        }

        .otp-submit-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 14px 32px rgba(99,91,255,0.6), inset 0 1px 0 rgba(255,255,255,0.15);
        }

        .otp-submit-btn:active:not(:disabled) { transform: translateY(0px); }

        .otp-submit-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        /* Spinner */
        .btn-spinner {
          width: 16px; height: 16px;
          border: 2px solid rgba(255,255,255,0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
        }

        @keyframes spin { to { transform: rotate(360deg); } }

        /* Back to Login link */
        .otp-back-row {
          text-align: center;
          margin-top: 1.75rem;
          font-size: 0.82rem;
          color: rgba(148, 163, 184, 0.55);
        }

        .otp-back-row button {
          background: none;
          border: none;
          font-size: 0.82rem;
          font-weight: 700;
          color: #818cf8;
          cursor: pointer;
          margin-left: 0.25rem;
          font-family: 'Inter', sans-serif;
          transition: color 0.2s;
          display: inline-flex;
          align-items: center;
          gap: 0.25rem;
        }

        .otp-back-row button:hover { color: #a78bfa; }

        /* Security badge */
        .otp-security-badge {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.4rem;
          margin-top: 1.5rem;
          font-size: 0.7rem;
          color: rgba(148,163,184,0.35);
          font-weight: 500;
          letter-spacing: 0.03em;
        }
      `}</style>

      <div className="otp-root">

        {/* ── LEFT PANEL ── */}
        <div className="otp-left">
          <div className="otp-grid" />
          <div className="otp-orb otp-orb-1" />
          <div className="otp-orb otp-orb-2" />

          <div className="left-content">
            <div className="left-brand-icon">
              <span className="material-icons" style={{ fontSize: "2rem", color: "white" }}>payments</span>
            </div>

            <div className="left-title">Gaadiaa<br />Trusted Payments</div>

            <p className="left-subtitle">
              Verify your security credentials to safely reset your password and keep your operations protected.
            </p>

            <div className="feature-pills">
              <div className="feature-pill">
                <div className="feature-pill-icon" style={{ background: "rgba(99,91,255,0.2)" }}>
                  <span className="material-icons" style={{ fontSize: "1.15rem", color: "#818cf8" }}>security</span>
                </div>
                <div className="feature-pill-text">
                  <strong>Two-Factor Authentication</strong>
                  <span>Safeguarding your account from unauthorized actions</span>
                </div>
              </div>

              <div className="feature-pill">
                <div className="feature-pill-icon" style={{ background: "rgba(16,185,129,0.15)" }}>
                  <span className="material-icons" style={{ fontSize: "1.15rem", color: "#34d399" }}>verified_user</span>
                </div>
                <div className="feature-pill-text">
                  <strong>Phishing Protection</strong>
                  <span>One-time dynamic codes bound to your session</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── RIGHT PANEL ── */}
        <div className="otp-right">
          <div className="otp-card">

            {/* Mobile-only brand */}
            <div className="mobile-brand">
              <div className="mobile-brand-icon">
                <span className="material-icons" style={{ fontSize: "1.5rem", color: "white" }}>payments</span>
              </div>
              <div style={{ fontSize: "1.1rem", fontWeight: 800, color: "#f1f5f9", letterSpacing: "-0.02em" }}>Gaadiaa</div>
              <div style={{ fontSize: "0.7rem", color: "rgba(148,163,184,0.5)", fontWeight: 500, letterSpacing: "0.1em", textTransform: "uppercase", marginTop: "2px" }}>Trusted Payments</div>
            </div>

            {/* Heading */}
            <div className="otp-heading">
              <h1>Two-step verification</h1>
              <p>
                We've sent a 6-digit recovery code to your registered address:<br />
                <span className="email-highlight">{email || "your email"}</span>
              </p>
            </div>

            <div className="otp-divider" />

            <form onSubmit={handleSubmit} autoComplete="off">

              {/* OTP Digit Inputs */}
              <div className="otp-digit-row">
                {[...Array(6)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={otp[index]}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    ref={(el) => (otpRefs.current[index] = el)}
                    className={`otp-digit-input ${errors.username ? "error" : ""}`}
                  />
                ))}
              </div>

              {errors.username && (
                <p className="otp-error-msg">
                  <span className="material-icons" style={{ fontSize: "0.85rem" }}>error_outline</span>
                  {errors.username}
                </p>
              )}

              {/* Submit */}
              <button
                type="submit"
                className="otp-submit-btn"
                disabled={loading}
                style={{ marginTop: "2rem" }}
              >
                {loading ? (
                  <>
                    <div className="btn-spinner" />
                    Validating OTP…
                  </>
                ) : (
                  <>
                    Verify & Reset Password
                    <span className="material-icons" style={{ fontSize: "1.1rem" }}>arrow_forward</span>
                  </>
                )}
              </button>
            </form>

            {/* Back to Login link */}
            <div className="otp-back-row">
              Remember your password?
              <button onClick={handleBackToLogin}>
                <span className="material-icons" style={{ fontSize: "1rem" }}>arrow_back</span>
                Back to Sign In
              </button>
            </div>

            {/* Security Badge */}
            <div className="otp-security-badge">
              <span className="material-icons" style={{ fontSize: "0.85rem" }}>verified</span>
              Dual-factor recovery protocol active
            </div>

          </div>
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        toastStyle={{ background: "#1e1b4b", color: "#e2e8f0", border: "1px solid rgba(99,91,255,0.2)" }}
      />
    </>
  );
};

export default ForgotOtp;
